import { ChangeEvent, useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

const useSorting = (defaultValue: string = '3') => {
  const [optionValue, setOptionValue] = useState(defaultValue);
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    const newSearchParams = new URLSearchParams(searchParams?.toString());
    newSearchParams.set('Order', value);
    const newUrl = `${window.location.pathname}?${newSearchParams.toString()}`;
    router.push(newUrl);
  };

  useEffect(() => {
    setOptionValue(searchParams?.get('Order') ?? defaultValue);
  }, [searchParams, defaultValue]);

  return { optionValue, handleChange };
};

export default useSorting;
